import type { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, of, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';

import { IntelligenceSettingsHttp } from './intelligence-settings.http';
import { IntelligenceSettingsActions } from './intelligence-settings.state';

export const loadIntelligenceSettingsEffect = createEffect(
  (actions$ = inject(Actions), http = inject(IntelligenceSettingsHttp)) =>
    actions$.pipe(
      ofType(IntelligenceSettingsActions.fetch),
      switchMap(() =>
        http.fetch().pipe(
          map(payload => IntelligenceSettingsActions.fetchSuccess({ payload })),
          catchError((error: HttpErrorResponse) =>
            of(IntelligenceSettingsActions.fetchFailed({ payload: error })),
          ),
        ),
      ),
    ),
  { functional: true },
);

export const updateIntelligenceSettingsEffect = createEffect(
  (actions$ = inject(Actions), http = inject(IntelligenceSettingsHttp)) =>
    actions$.pipe(
      ofType(IntelligenceSettingsActions.update),
      switchMap(({ payload }) =>
        http.update(payload).pipe(
          map(payload => IntelligenceSettingsActions.updateSuccess({ payload })),
          catchError((error: HttpErrorResponse) =>
            of(IntelligenceSettingsActions.updateFailed({ payload: error })),
          ),
        ),
      ),
    ),
  { functional: true },
);
